import { Button, Paper, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import axios from "../../config/authaxios";
import Dropdown from "../../css/dropdown.module.scss";
import { useStyles } from "../../theme/theme";
import { IconButton, Typography, Chip, Stack, Autocomplete, Avatar } from "@mui/material";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { useNavigate, useParams } from 'react-router-dom';
import Body from "../../ui/Body"
import Nabvar from "../../common/Nabvar";
import Sidebar from "../../common/Sidebar";

function PulisherCategory() {
  const { publisherId } = useParams();
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [PublisherCategories, setPublisherCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const classes = useStyles();
  const [openCategory, setOpenCategory] = useState(false);
  const [initialCategories, setInitialCategories] = useState([]);

  const CouponsColomns = [
    {
      field: "s_no",
      headerName: "S. No.",
      headerClassName: "super-app-theme--header",
      flex: 1,
      filterable: false,
      renderCell: (index) =>
        index.api?.getRowIndexRelativeToVisibleRows(index.row._id) + 1,
    },
    {
      field: "_id",
      headerName: "ID",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 250,
    },
    {
      field: "image",
      headerName: "Image",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <Avatar
          src={params.row.image}
          alt={params.row.name}
          sx={{ width: 40, height: 40 }}
          variant="rounded"
        />
      ),
    },
    {
      field: "name",
      headerName: "Name",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "cashback_percentage",
      headerName: "Cashback Percentage",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "is_deleted",
      headerName: "Is Deleted",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 200,
    },


  ];

  const handleSubmit = () => {
    const newSelectedIds = selectedCategories.map(cat => cat._id);
    const oldSelectedIds = initialCategories.map(cat => cat._id);
    const addedCategories = newSelectedIds.filter(id => !oldSelectedIds.includes(id));
    const removedCategories = oldSelectedIds.filter(id => !newSelectedIds.includes(id));
    axios.post(`/admin/add/category/to/publisher`, {
      publisher_id: publisherId,
      added_categories: addedCategories,
      removed_categories: removedCategories,
    })
      .then((res) => {
        alert(res?.data?.message || "Categories updated successfully!");
        setOpenCategory(false);
        setInitialCategories(selectedCategories);
        getFetchData();
      })
      .catch((err) => {
        console.error("Error updating categories", err);
      });
  };

  const getFetchData = async () => {
    try {
      const catRes = await axios.get(`/admin/product/categories`);
      const allCategories = catRes?.data?.response || [];
      setCategories(allCategories);

      const pubRes = await axios.get(`/admin/getPublisherCategory/${publisherId}`);

      const publisherCatIds = pubRes?.data?.data || [];
      setInitialCategories(publisherCatIds);
      const selected = allCategories.filter(cat =>
        publisherCatIds.some(pub => pub._id === cat._id)
      );
      setPublisherCategories(selected);
      setSelectedCategories(selected);
    } catch (err) {
      console.error("Error loading data", err);
    }
  };


  useEffect(() => {
    getFetchData();
  }, []);


  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "12px",
  };

  return (
    <>
      <Sidebar />
      <Nabvar />
      <Body>
        <section>
          <section>
            <section style={{ width: "45%" }}>
              <Button
                variant="contained"
                sx={{ ml: 1, my: 2 }}
                color="info"
                className={Dropdown.dropbtn}
                onClick={() => setOpenCategory(true)}
              >
                Add Category
              </Button>
            </section>
          </section>
          <Paper
            sx={{
              bgcolor: "#fff",
              "& .super-app-theme--header": {
                bgcolor: "#DC8449",
                color: "#fff",
              },
            }}
            elevation={0}
          >
            <DataGrid
              className={classes.root}
              sx={{
                border: 0,
              }}
              hideFooterPagination
              // getRowHeight={() => 'auto'}
              autoHeight
              rows={PublisherCategories}
              columns={CouponsColomns}
              getRowId={(row) => row._id}
              disableSelectionOnClick
              disableRowSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              disableColumnSelector
            />
          </Paper>
        </section>
        <Modal
          open={openCategory}
          onClose={() => setOpenCategory(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Add Category
            </Typography>
            <Autocomplete
              multiple
              options={categories}
              disableCloseOnSelect
              getOptionLabel={(option) => option.name}
              value={selectedCategories}
              onChange={(event, newValue) => setSelectedCategories(newValue)}
              isOptionEqualToValue={(option, value) => option._id === value._id} // 👈 important
              renderOption={(props, option) => (
                <Box component="li" sx={{ display: "flex", alignItems: "center", gap: 1 }} {...props}>
                  <Avatar src={option.image} alt={option.name} sx={{ width: 30, height: 30 }} />
                  {option.name}
                </Box>
              )}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    key={option._id}
                    avatar={<Avatar src={option.image} />}
                    label={option.name}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => <TextField {...params} label="Select Categories" />}
              sx={{ mt: 2 }}
            />
            <Box
              sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}
            >
              <Button onClick={() => setOpenCategory(false)}>Cancel</Button>
              <Button
                variant="contained"
                onClick={() => handleSubmit(selectedCategories)}
              >
                Add
              </Button>
            </Box>
          </Box>
        </Modal>
      </Body>
    </>
  );
}

export default PulisherCategory;
